import Container from "@client/content/Containers/container";
import { getContainerProps } from "@client/content/lib/helper";
import { type RootContainerProps } from "@client/content/types";
import * as React from "react";
import Content from "./Content/container";

import { type WithIsEditMode } from "@client/types";

import "./style.less";

export type MapProps = RootContainerProps &
  WithIsEditMode & {
    className: string;
    hasPost: boolean;
  };

export interface ActionProps {}

type Props = ActionProps & MapProps;
export default (props: Props) => {
  const { className, hasPost } = props;

  return (
    <Container className={className} {...getContainerProps(props)}>
      {hasPost ? (
        <Content {...props} />
      ) : props.isEditMode ? (
        <span>{`There's no post. Please make sure the current URL (${window.location.href}) contains a permalink`}</span>
      ) : null}
    </Container>
  );
};
